import { TFunction } from "i18next";
import { Folder, Folders, GraduationCap } from "lucide-react";
import { TabItem } from "@components/TabsCst/types";

export const GROUP_LO_TYPE_BY_TAB: Record<string, string> = {
  activities: "DIDACTICAL_ACTIVITY",
  courses: "COURSE",
  paths: "PATH",
};

export const buildGroupLoTypeFilter = (
  loTab: string,
): Record<string, string> | undefined =>
  GROUP_LO_TYPE_BY_TAB[loTab]
    ? { loType: GROUP_LO_TYPE_BY_TAB[loTab] }
    : undefined;

export const buildGroupLoTabs = (t: TFunction): TabItem[] => [
  { key: "all", label: String(t("lo.tabs.all")), icon: <></> },
  {
    key: "activities",
    label: String(t("lo.tabs.activities")),
    icon: <GraduationCap size={"0.75rem"} />,
  },
  {
    key: "courses",
    label: String(t("lo.tabs.courses")),
    icon: <Folder size={"0.75rem"} />,
  },
  {
    key: "paths",
    label: String(t("lo.tabs.paths")),
    icon: <Folders size={"0.75rem"} />,
  },
];
